import { render } from "./ContactUsComponent.vue?vue&type=template&id=627dee6f&scoped=true"
import script from "./ContactUsComponent.vue?vue&type=script&lang=js"
export * from "./ContactUsComponent.vue?vue&type=script&lang=js"

import "./ContactUsComponent.vue?vue&type=style&index=0&id=627dee6f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-627dee6f"]])

export default __exports__